import { createRouter, createWebHistory } from 'vue-router';
import { auth } from '../services/auth';
import LoginView from '../views/LoginView.vue';
import DashboardView from '../views/DashboardView.vue';
import ProfileView from '../views/ProfileView.vue';
import InvoiceListView from '../views/InvoiceListView.vue';
import ClientesView from '../views/ClientesView.vue';
import CuentasCorrientesView from '../views/CuentasCorrientesView.vue';
import ReportesView from '../views/ReportesView.vue';
import ResetPasswordView from '../views/ResetPasswordView.vue';
import FacturacionMensualView from '../views/FacturacionMensualView.vue';
import GastosView from '../views/GastosView.vue';
import RadarComexView from '../views/RadarComexView.vue';

const routes = [
  { path: '/login',          name: 'Login',         component: LoginView,         meta: { public: true } },
  { path: '/reset-password', name: 'ResetPassword', component: ResetPasswordView, meta: { public: true } },
  { path: '/',          redirect: '/dashboard' },
  { path: '/dashboard', name: 'Dashboard', component: DashboardView },
  { path: '/clientes',  name: 'Clientes',  component: ClientesView },
  { path: '/facturas',  name: 'Facturas',  component: InvoiceListView },
  { path: '/cuentas',   name: 'Cuentas',   component: CuentasCorrientesView },
  { path: '/facturacion', name: 'Facturacion', component: FacturacionMensualView },
  { path: '/gastos',    name: 'Gastos',    component: GastosView },
  { path: '/reportes',  name: 'Reportes',  component: ReportesView },
  { path: '/radar',     name: 'RadarComex', component: RadarComexView },
  { path: '/profile',   name: 'Profile',   component: ProfileView }
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

router.beforeEach((to) => {
  if (!to.meta.public && !auth.isLoggedIn) {
    return { name: 'Login', query: to.path !== '/' ? { redirect: to.fullPath } : {} };
  }
  if (to.name === 'Login' && auth.isLoggedIn) {
    return { name: 'Dashboard' };
  }
});

export default router;
